import { ChangeEvent, FC, useCallback, useEffect, useState } from 'react';
import {
  MerchantConfigurationsOutputData,
  MerchantConfigurationsOutputSelectData,
  OpenInputType,
} from '../../../../../middlewares/Open/openTypes';
import CustomSelect from '../../../common/CustomSelect';
import useColors from '../../../../../hooks/useColors';

interface MerchantCommissionsSelectProps {
  merchantConfiguration: MerchantConfigurationsOutputData;
  dismissed: boolean;
  inputs: OpenInputType;
}

const MerchantCommissionsSelect: FC<MerchantCommissionsSelectProps> = (
  props
) => {
  const { merchantConfiguration, inputs } = props;
  const { secondaryColor } = useColors();
  const [commission, setCommission] = useState<number | null>(null);
  const [totalAmount, setTotalAmount] = useState<number | null>(null);
  const val = inputs[merchantConfiguration.name];
  const originalAmount = parseInt(`${inputs['amount']}`);

  const updateCommissionsValues: (value: string | number) => void = useCallback(
    (value) => {
      if (value == '') {
        setCommission(null);
        setTotalAmount(null);
        return;
      }

      const label = (
        merchantConfiguration.data as MerchantConfigurationsOutputSelectData[]
      )
        .map((el) => ({ label: el.value.label, value: el.value.value }))
        .filter((el) => el.value === value)[0]?.label;

      if (!label || !originalAmount) {
        setCommission(null);
        setTotalAmount(null);
        return;
      }

      const commissionLabel = label.split(' - ')[label.split(' - ').length - 1];
      const commissionType = commissionLabel.includes('%')
        ? 'percentage'
        : 'fixed';
      const commissionValue = commissionLabel
        .replaceAll('%', '')
        .replaceAll('$', '')
        .replaceAll('+', '')
        .trim();

      let commissionAmount = 0;

      if (commissionType === 'percentage') {
        const newAmount =
          originalAmount / (1 - parseFloat(commissionValue) / 100);
        commissionAmount = parseInt(`${Math.ceil(newAmount) - originalAmount}`);
      } else {
        commissionAmount = parseInt(commissionValue);
      }

      setCommission(commissionAmount);
      setTotalAmount(originalAmount + commissionAmount);
    },
    [merchantConfiguration.data, originalAmount]
  );

  useEffect(() => {
    updateCommissionsValues(val);
  }, [val, updateCommissionsValues]);

  const updateAmounts = (e: ChangeEvent<HTMLSelectElement>) => {
    e.preventDefault();
    updateCommissionsValues(inputs[merchantConfiguration.name]);
  };

  return (
    <>
      <div className="mx-auto w-11/12 text-left">
        <label
          htmlFor="amount"
          className="text-sm font-semibold w-full mr-auto"
          style={{ color: secondaryColor }}
        >
          {merchantConfiguration.label}:
        </label>
        <CustomSelect
          handleChange={updateAmounts}
          id={merchantConfiguration.name}
          placeholder=""
          name={merchantConfiguration.name}
          value={inputs[merchantConfiguration.name] || ''}
          options={[
            { label: 'Selecciona el medio de pago...', value: '' },
            ...(
              merchantConfiguration.data as MerchantConfigurationsOutputSelectData[]
            ).map((item) => ({
              label: item.value.label,
              value: item.value.value,
            })),
          ]}
        />
        {commission != null && (
          <div className="mt-2 flex flex-col gap-1">
            <p className="text-sm font-normal w-full mr-auto">
              Monto comisión: ${commission}
            </p>
            <p
              className="text-md font-semibold w-full mr-auto"
              style={{ color: secondaryColor }}
            >
              Monto total: ${totalAmount}
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default MerchantCommissionsSelect;
